<template>
    <div>
        <v-view :tableData="tableData"
                :tableProps="tableProps"
                :modalProps="modalProps"
                :columns="columns"
                :routes="routes"
                :initialSort="initialSort"
                :rowButtonAction="rowButtonAction"
                :buttonsVisibility="buttonsVisibility"
                v-model:selectedRows="selectedRows">

            <template #crud="formProps">
                <KnowledgeForm :formProps="formProps">
                </KnowledgeForm>
            </template>
            <template #search="searchProps">
                <KnowledgeSearch :searchProps="searchProps">
                </KnowledgeSearch>
            </template>

        </v-view>
    </div>
</template>

<script setup>
import KnowledgeForm from './KnowledgeForm.vue'
import KnowledgeSearch from './KnowledgeSearch.vue'
import { rowButtonAction } from '@pages/Helper/crud_utils.js'
import { ref } from "vue";

const props = defineProps({
    tableData: Object,
    tableProps: Object,
    modalProps: Object,
    columns: Object,
    routes: Object,
    initialSort: Object,
    buttonsVisibility: Object,
})

const selectedRows = ref([])

//------------------------------------------------------------------------------

</script>

<style lang="scss" scoped></style>
